import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from '@/components/layout/Layout';
import { ScrollToTop } from '@/components/common/ScrollToTop';
import { HomePage } from '@/pages/HomePage';
import { DownloadPage } from '@/pages/DownloadPage';
import { DownloadGuidePage } from '@/pages/DownloadGuidePage';
import { CMSFeaturesPage } from '@/pages/CMSFeaturesPage';
import { ProductDetailPage } from '@/pages/ProductDetailPage';
import '@/assets/css/style.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/cms-features" element={<CMSFeaturesPage />} />
          <Route path="/product/:id" element={<ProductDetailPage />} />
          <Route path="/download" element={<DownloadPage />} />
          <Route path="/download-guide" element={<DownloadGuidePage />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
